import $ from "jquery";

import coreApiRoot from "@/utils/coreApiRoot";

const root = coreApiRoot() + "/api/brand";

function headers() {
  return {
    "X-Legacy-Tenant-Id": localStorage.getItem("UserComSysno") || "OKR-DEMO-COMPANY",
    "X-Legacy-User-Id": localStorage.getItem("UserSysno") || "OKR-DEMO-USER"
  };
}

function request(method, path, data) {
  return new Promise((resolve, reject) => $.ajax({
    type: method,
    url: root + path,
    headers: headers(),
    contentType: "application/json; charset=UTF-8",
    dataType: "json",
    data: method === "GET" ? data : JSON.stringify(data || {}),
    success: resolve,
    error(xhr) {
      const body = xhr.responseJSON || {};
      reject(new Error(body.message || "品牌服务暂时不可用"));
    }
  }));
}

function upload(file) {
  const data = new FormData(); data.append("file", file);
  return new Promise((resolve, reject) => $.ajax({type:"POST",url:root+"/materials",headers:headers(),data,
    processData:false,contentType:false,dataType:"json",success:resolve,error(xhr){const body=xhr.responseJSON||{};reject(new Error(body.message||"素材上传失败"));}}));
}

export default {
  status: () => request("GET", "/status"),
  requirements: () => request("GET", "/requirements"),
  saveRequirement: data => request("POST", "/requirements", data),
  contents: all => request("GET", "/contents", { all: !!all }),
  createContent: data => request("POST", "/contents", data),
  updateContent: (id, data) => request("PUT", `/contents/${id}`, data),
  generateEvaluate: id => request("POST", `/contents/${id}/generate-evaluate`, {}),
  publish: (id, data) => request("POST", `/contents/${id}/publish`, data),
  report: () => request("GET", "/report"),
  intelligence: () => request("GET", "/intelligence"),
  employeeRank: period => request("GET", "/rankings/employees", { period }),
  projectRank: period => request("GET", "/rankings/projects", { period }),
  employeeTrend: (employeeId, months = 6) => request("GET", `/rankings/employees/${employeeId}/trend`, { months }),
  advices: params => request("GET", "/strategy/advices", params || {}),
  generateAdvice: data => request("POST", "/strategy/advices/generate", data),
  dispatchAdvice: (id, employeeId) => request("POST", `/strategy/advices/${id}/dispatch`, { employeeId }),
  createSkillPatch: id => request("POST", `/strategy/advices/${id}/skill-patch`, {}),
  platformCapabilities: () => request("GET", "/platforms/capabilities"),
  platformAccounts: () => request("GET", "/platforms/accounts"),
  bindPlatformContent: (id, data) => request("POST", `/contents/${id}/platform-bindings`, data),
  importPlatformMetrics: (id, data) => request("POST", `/contents/${id}/platform-metrics/import`, data),
  syncPlatformMetrics: (id, platform) => request("POST", `/contents/${id}/platform-metrics/sync`, { platform }),
  platformMetrics: id => request("GET", `/contents/${id}/platform-metrics`),
  analyzeVideo: (id, data) => request("POST", `/contents/${id}/video-analysis`, data),
  videoAnalyses: id => request("GET", `/contents/${id}/video-analysis`),
  saveOutcome: (id, data) => request("PUT", `/contents/${id}/outcome`, data),
  outcome: id => request("GET", `/contents/${id}/outcome`),
  complianceReview: id => request("POST", `/contents/${id}/compliance-review`, {}),
  complianceReviews: id => request("GET", `/contents/${id}/compliance-reviews`),
  predictContent: id => request("POST", `/contents/${id}/prediction`, {}),
  comparePrediction: id => request("POST", `/contents/${id}/prediction/compare`, {}),
  predictions: id => request("GET", `/contents/${id}/predictions`),
  nominateSample: (id, data) => request("POST", `/contents/${id}/samples`, data),
  samples: status => request("GET", "/samples", { status }),
  reviewSample: (id, data) => request("POST", `/samples/${id}/review`, data),
  uploadMaterial: file => upload(file)
};



// WEBPACK FOOTER //
// ./src/api/brand.js